(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-house"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-house')) {
    class BrandHouse extends HTMLElement {
      connectedCallback() {
        this.t = (k, v) => { let s = this.dataset[k] || ''; for (const [a, b] of Object.entries(v || {})) s = s.split(a).join(b); return s; };
        this.need = 'all';
        this.rows = Array.from(this.querySelectorAll('[data-row]'));
        this.chips = Array.from(this.querySelectorAll('.bh__chip'));
        this.labels = {};
        this.chips.forEach((c) => { if (c.dataset.label) this.labels[c.dataset.need] = c.dataset.label; });

        this.rows.forEach((row, i) => {
          row.querySelector('[data-toggle]').addEventListener('click', () => this.toggle(i));
          row.querySelectorAll('[data-card]').forEach((card) => {
            const tags = (card.dataset.needs || '').split(' ').filter(Boolean);
            card.querySelector('[data-tags]').textContent = tags.map((t) => this.labels[t] || t).join(' · ');
          });
          this.addMobileCta(row);
        });

        this.chips.forEach((chip) => chip.addEventListener('click', () => this.filter(chip.dataset.need)));
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-add]');
          if (btn) this.add(btn);
        });
      }

      addMobileCta(row) {
        const cta = row.querySelector('.bh__cta');
        const body = row.querySelector('.bh__panel-body');
        if (!cta || !body) return;
        const clone = cta.cloneNode(true);
        clone.classList.add('bh__mobile-cta');
        body.appendChild(clone);
      }

      toggle(i, forceOpen) {
        this.rows.forEach((row, j) => {
          const open = forceOpen ? j === i : j === i && !row.classList.contains('is-open');
          row.classList.toggle('is-open', open);
          row.querySelector('[data-toggle]').setAttribute('aria-expanded', String(open));
        });
        const row = this.rows[i];
        if (row && row.classList.contains('is-open') && window.matchMedia('(max-width: 749px)').matches) {
          setTimeout(() => row.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
        }
      }

      filter(need) {
        this.need = need;
        this.chips.forEach((c) => {
          const on = c.dataset.need === need;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', String(on));
        });
        const label = (this.labels[need] || '').toLowerCase();
        let best = -1, bestN = 0, openIx = this.rows.findIndex((r) => r.classList.contains('is-open'));

        this.rows.forEach((row, i) => {
          const cards = Array.from(row.querySelectorAll('[data-card]'));
          let n = 0;
          cards.forEach((card) => {
            const hit = need === 'all' || (card.dataset.needs || '').split(' ').includes(need);
            card.classList.toggle('is-dim', !hit);
            if (hit) n++;
          });
          const count = row.querySelector('[data-count]');
          const notice = row.querySelector('[data-notice]');
          const total = count ? count.dataset.total : cards.length;
          if (need === 'all') {
            if (count) count.textContent = this.t('i18nProducts', { __N__: total });
            if (notice) notice.textContent = this.t('i18nEssentials', { __N__: total });
          } else {
            if (count) count.textContent = n ? this.t('i18nNFor', { __N__: n, __L__: label }) : this.t('i18nNoMatch');
            if (notice) notice.textContent = n ? this.t('i18nNOfFor', { __N__: n, __T__: cards.length, __L__: label }) : this.t('i18nNothingFor', { __L__: label });
          }
          if (n > bestN) { bestN = n; best = i; }
          row.dataset.matches = n;
        });

        if (this.dataset.autoOpen === 'true' && need !== 'all' && best >= 0) {
          const current = openIx >= 0 ? Number(this.rows[openIx].dataset.matches) : 0;
          if (!current) this.toggle(best, true);
        }
      }

      async add(btn) {
        btn.classList.add('is-loading');
        const original = btn.textContent;
        try {
          const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.dataset.add), quantity: 1 }] })
          });
          if (!res.ok) throw new Error('add failed');
          const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.dataset.sectionId,
              data: { source: 'brand-house', itemCount: cart.item_count, didError: false }
            }
          }));
          btn.textContent = 'Added to cart';
          btn.classList.add('is-added');
          setTimeout(() => { btn.textContent = original; btn.classList.remove('is-added'); }, 2200);
        } catch (e) {
          btn.textContent = 'Try again';
          setTimeout(() => { btn.textContent = original; }, 2000);
        } finally {
          btn.classList.remove('is-loading');
        }
      }
    }
    customElements.define('brand-house', BrandHouse);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
